import { Component } from '@angular/core';

@Component({
  selector: 'allas-canjea-puntos',
  imports: [],
  template: `
    <section class="grid grid-cols-1 xl:grid-cols-2 gap-4">
      <!-- Canjea tus puntos en tienda -->
      <article
        class="gap-6 xl:gap-2 w-full bg-gray-100 p-4 xl:p-8 grid grid-cols-12 xl:grid-cols-6"
      >
        <span class="flex items-center justify-center col-span-3 xl:col-span-2">
          <img
            src="/images/services/afiliaciones/store.webp"
            alt="store"
            class="w-full xl:w-2/3 h-full xl:h-2/3 object-contain"
          />
        </span>
        <div class="flex flex-col gap-2 col-span-9 xl:col-span-4">
          <h2 class="text-lg xl:text-3xl font-extrabold fs-condensed">
            CANJEA TUS PUNTOS EN ALLAS REPUESTOS
          </h2>
          <p class="text-xs xl:text-xl font-light">
            Para Canjear tus Recompensas en una tienda Allas Repuestos, desde tu
            Aplicación, selecciona los premios que deseas, selecciona "CANJEAR
            AHORA", la aplicación te generará un código, dáselo a tu asesor y el
            te hará el resto del proceso.
          </p>
        </div>
      </article>
      <!-- Canjea tus puntos en la PC -->
      <article
        class="gap-6 xl:gap-2 w-full bg-gray-100 p-4 xl:p-8 grid grid-cols-12 xl:grid-cols-6"
      >
        <span class="flex items-center justify-center col-span-3 xl:col-span-2">
          <img
            src="/images/services/afiliaciones/computer-points.webp"
            alt="store"
            class="w-full xl:w-2/3 h-full xl:h-2/3 object-contain"
          />
        </span>
        <div class="flex flex-col gap-2 col-span-9 xl:col-span-4">
          <h2 class="text-lg xl:text-3xl font-extrabold fs-condensed">
            CANJEA TUS PUNTOS EN ALLASREPUESTOS.COM
          </h2>
          <p class="text-xs xl:text-xl font-light">
            Al realizar cualquier compra en línea en el momento del checkout
            tendrás la opción de Canjear Premios, selecciona el tuyo, y finaliza
            tu compra. Tu premio será enviado con tu orden.
          </p>
        </div>
      </article>
    </section>

    <article class="bg-gray-100 grid grid-cols-1 xl:grid-cols-12 gap-2 mt-4">
      <div
        class="col-span-12 xl:col-span-8 flex flex-col gap-2 items-center justify-center p-6"
      >
        <h2
          class="text-2xl xl:text-5xl font-black fs-condensed xl:text-center w-full"
        >
          COMIENZA A GANAR PUNTOS EN TUS COMPRAS
        </h2>
        <span
          class="flex flex-col xl:flex-row gap-2 items-center xl:justify-center"
        >
          <span class="text-base xl:text-2xl font-light">
            Canjea por premios que podrás ver en nuestra APP
          </span>
          <img
            src="/logos/default.webp"
            alt="Allas Logo"
            class="h-8 self-start"
          />
        </span>
      </div>
      <div class="col-span-12 xl:col-span-4 mt-6">
        <img
          src="/images/services/afiliaciones/mobile-benefits.webp"
          alt="Points App"
          class="w-full "
        />
      </div>
    </article>
  `,
})
export class CanjeaPuntos {}
